{
    "AdminControl_PolicyApplied": "Toegepast beleid",
    "AdminControl_RecordingPolicyDetails": "Details van het opnamebeleid",
    "AdminControl_DisplayName": "Weergavenaam:",
    "AdminControl_UserPrincipalName": "Gebruikersprincipalnaam",
    "AdminControl_TeamsComplianceRecordingPolicy": "Teams Compliance Recording Policy",
    "AdminControl_PresenceStatus": "Aanwezigheidsstatus",
    "AdminControl_CopiedToClipboard": "Gekopieerd naar het klembord",
    "AdminControl_ResponseSuccess": "Taak succesvol afgerond",
    "NAME": "AdminControlLanguage"
}